import React, {Component} from "react";
import Presval from "./Presval";
import axios from "axios";
import {Growl} from "primereact/growl";

export default class App extends Component {
    constructor(props) {
        super(props);


        this.state = {};
    }

    showMessage(message) {
        alert(message);
    }

    componentDidMount() {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        axios.interceptors.request.use(
            function (config) {
                // Do something before request is sent
                config.withCredentials = true;
                return config;
            },
            function (error) {
                // Do something with request error
                return Promise.reject(error);
            }
        );

        axios.interceptors.response.use(
            function (response) {

                let notSession = response.data.includes !== undefined ? response.data.includes("No existe Sesión") : false;

                if ( notSession ||
                    (response.headers['content-disposition'] === undefined && false)
                ) {
                    alert('No existe Sesión');
                    localStorage.clear();

                    window.location.reload();
                } else {
                    return response;
                }
            },
            function (error) {
                let online = window.navigator.onLine;
                let status = error.response !== undefined ? error.response.status : 0;
                let url = error.request !== undefined ? error.request.responseURL : "";
                console.log(error);

                if (error.response) {
                    // The server responded with a status code outside the 2xx range
                    console.log('Error response:', error.response);
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log('Error request:', error.request);
                } else {
                    // Something happened in setting up the request that triggered an error
                    console.log('Error message:', error.message);
                }
                if (!url.includes("getControlPanelLoan")){
                    alert("Servicio no Disponible\nOnline:" + online + "\nStatus:" + status);
                }
                return error;
            }
        );
    }


    static addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    static removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return (
            <Presval
                messagesGrowl={messagesGrowl}
            />
        );
    }
}